import { Card, CardContent, TextField } from "@material-ui/core";
// import { makeStyles } from "@material-ui/styles";
import { ClusterCreate_clusterCreate_errors } from "@saleor/cluster/types/ClusterCreate";
import CardTitle from "@saleor/components/CardTitle";
import FormSpacer from "@saleor/components/FormSpacer";
import SingleSelectField from "@saleor/components/SingleSelectField";
import { FormChange } from "@saleor/hooks/useForm";
import { commonMessages } from "@saleor/intl";
import { getFormErrors } from "@saleor/utils/errors";
import getClusterErrorMessage from "@saleor/utils/errors/cluster";
import React from "react";
import { useIntl } from "react-intl";

import { ClusterFormData } from "../ClusterCreatePage";

export interface ClusterInfoProps {
  data: ClusterFormData;
  errors: ClusterCreate_clusterCreate_errors[];
  disabled: boolean;
  localError: { name: string; productType: string };
  onChange: FormChange;
}

const storeType = [
  { label: "Food and Beverages", value: "FOOD_AND_BEVERAGES" },
  { label: "General Merchandise", value: "GENERAL_MERCHANDISE" }
];

const ClusterInfo: React.FC<ClusterInfoProps> = props => {
  const { data, disabled, onChange, localError, errors } = props;
  const intl = useIntl();

  const formErrors = getFormErrors(["name", "productType"], errors || []);

  return (
    <Card>
      <CardTitle
        title={intl.formatMessage(commonMessages.generalInformations)}
      />
      <CardContent>
        <TextField
          id="nameTxt"
          error={!!formErrors.name || !!localError.name}
          helperText={
            !!localError.name
              ? localError.name
              : getClusterErrorMessage(formErrors.name, intl)
          }
          disabled={disabled}
          fullWidth
          label={intl.formatMessage({
            defaultMessage: "Name",
            description: "Cluster title"
          })}
          name="name"
          value={data.name}
          onChange={onChange}
        />
        <FormSpacer />
        <div>
          <SingleSelectField
            choices={storeType}
            disabled={true}
            label={intl.formatMessage({
              defaultMessage: "Classification (GM/F&B)"
            })}
            name="productType"
            onChange={onChange}
            value={storeType[0].value || ""}
            error={!!formErrors.productType}
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default ClusterInfo;
